/**
 * @fileoverview Re-export from modular model maps structure
 * 
 * This file maintains backwards compatibility by re-exporting
 * all functionality from the new modular structure.
 * 
 * @version 4.0.0
 */

// Re-export everything from the modular structure
export * from './modelMaps/index';